/**
 * API origin for fetch(). Empty string means same-origin `/api` via nginx.
 *
 * An HTTPS page that calls an HTTP backend is mixed content — Chrome reports
 * that as "Failed to fetch". Prefer same-origin whenever we are already on
 * the public site (apex, www, or a matching configured host).
 */
export function getApiBase() {
  const configured = String(process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
  if (typeof window === 'undefined') return configured;
  if (!configured) return '';
  try {
    const cfg = new URL(configured, window.location.origin);
    const here = window.location;
    if (here.protocol === 'https:' && cfg.protocol === 'http:') return '';
    const norm = (host) => host.replace(/^www\./, '').toLowerCase();
    if (norm(cfg.hostname) === norm(here.hostname)) return '';
  } catch {
    return '';
  }
  return configured;
}

export const API_BASE = getApiBase();
